import React from "react";
import { FEATURES } from "../content";
import { Reveal } from "../hooks";

export function FeaturesSection({ sectionId = "features", showIntro = true }) {
  return (
    <section
      {...(sectionId ? { id: sectionId } : {})}
      className="py-24 px-4 relative overflow-hidden"
      data-testid="features-section"
      style={{
        background:
          "linear-gradient(180deg, hsl(220 25% 97%) 0%, hsl(220 20% 95%) 50%, hsl(220 25% 97%) 100%)",
      }}
    >
      <div
        className="absolute top-0 right-0 w-[700px] h-[700px] pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at top right, hsla(221, 100%, 50%, 0.10) 0%, transparent 70%)",
        }}
      />
      <div className="max-w-7xl mx-auto">
        {showIntro && (
          <Reveal>
            <div className="text-center mb-14">
              <div className="text-xs font-mono font-medium text-primary uppercase tracking-widest mb-3">
                THE PLATFORM
              </div>
              <h2 className="text-3xl sm:text-4xl font-cabinet font-black tracking-tight mb-4">
                Practice with precision
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl mx-auto font-plex">
                Every feature is built around data — so your preparation is
                targeted, measurable, and effective.
              </p>
            </div>
          </Reveal>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map(({ icon: Icon, title, desc, tag }, i) => (
            <Reveal key={title} delay={i * 0.07}>
              <div className="bg-card rounded-2xl p-6 border border-border hover:border-foreground/15 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group h-full">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-11 h-11 bg-primary/10 text-primary rounded-xl flex items-center justify-center group-hover:bg-[#0A0A0A] group-hover:text-white transition-all duration-300">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="text-[10px] font-bold text-primary bg-primary/10 px-2.5 py-1 rounded-full font-mono tracking-wider">
                    {tag}
                  </span>
                </div>
                <h3 className="text-base font-bold mb-2 font-cabinet">
                  {title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed font-plex">
                  {desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
